// extracted by mini-css-extract-plugin
export default {"container":"Header_container__U43cZ","logo":"Header_logo__FeIKw","infos":"Header_infos__n3L6B","info":"Header_info__C2-FK"};